import { render, staticRenderFns } from "./UserStatusIdBadge.vue?vue&type=template&id=46284567"
import script from "./UserStatusIdBadge.vue?vue&type=script&lang=js"
export * from "./UserStatusIdBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports